import { render, staticRenderFns } from "./SizesGuideProductDetail.vue?vue&type=template&id=2eda21c8&"
import script from "./SizesGuideProductDetail.vue?vue&type=script&lang=js&"
export * from "./SizesGuideProductDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports